// src/App.js
import React, { useState, createContext, useMemo, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Home from './components/Home';
import Shop from './components/Shop';
import Contact from './components/Contact';
import Cart from './components/Cart';
import Checkout from './components/Checkout';
import ProductDetail from './components/ProductDetail';
import productsData from './data/products';
import AOS from 'aos';
import 'aos/dist/aos.css';

export const CartContext = createContext();
export const ProductsContext = createContext();

function App() {
  const [cart, setCart] = useState(() => {
    try {
      const raw = localStorage.getItem('cart');
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  });
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true, // Animate only once
    });
  }, []);

  useEffect(() => {
    try {
      localStorage.setItem('cart', JSON.stringify(cart));
    } catch (e) {
      console.warn('Could not persist cart', e);
    }
  }, [cart]);

  const addToCart = (productToAdd) => {
    setCart(prev => {
      // if you want to combine identical items by id + selectedSize + selectedColor
      const key = (item) => `${item.id}::${item.selectedSize||''}::${item.selectedColor||''}`;

      const existingIndex = prev.findIndex(i => key(i) === key(productToAdd));
      if (existingIndex >= 0) {
        const newArr = [...prev];
        newArr[existingIndex] = {
          ...newArr[existingIndex],
          quantity: (newArr[existingIndex].quantity || 1) + (productToAdd.quantity || 1),
          price: productToAdd.price ?? newArr[existingIndex].price ?? (Object.values(productToAdd.prices || {})[0] || 0),
        };
        return newArr;
      } else {
        return [...prev, { ...productToAdd, quantity: productToAdd.quantity || 1, price: productToAdd.price ?? (Object.values(productToAdd.prices || {})[0] || 0) }];
      }
    });
  }

  const removeFromCart = (id) => {
    setCart((prev) => prev.filter((item) => item.id !== id));
  };

  const updateQuantity = (id, quantity) => {
    setCart((prev) =>
      prev.map((item) => (item.id === id ? { ...item, quantity } : item))
    );
  };

  const cartValue = useMemo(() => ({ cart, addToCart, removeFromCart, updateQuantity }), [cart]);
  const productsValue = useMemo(() => ({ products: productsData, searchQuery, setSearchQuery }), [searchQuery]);

  return (
    <CartContext.Provider value={cartValue}>
      <ProductsContext.Provider value={productsValue}>
        <div className="App">
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/product/:id" element={<ProductDetail />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />
          </Routes>
        </div>
      </ProductsContext.Provider>
    </CartContext.Provider>
  );
}

export default App;